import { statusBadgeTones } from '@/components/StatusBadge';

export const INVOICE_TYPE_LABELS = {
  subscription: 'Subscription Payment',
  upgrade: 'New Seat Payment',
  refund: 'Refund Payment',
  failed: 'Failed Payment',
};

export function getInvoiceTypeLabel(type) {
  return INVOICE_TYPE_LABELS[type] || 'Payment';
}

export const INVOICE_TYPE_FILTER_OPTIONS = [
  { value: null, label: 'All Types' },
  { value: 'subscription', label: 'Subscription Payment' },
  { value: 'upgrade', label: 'New Seat Payment' },
  { value: 'refund', label: 'Refund Payment' },
  { value: 'failed', label: 'Failed Payment' },
];

const PAID_PAYMENT_STATUSES = ['captured', 'paid', 'processed'];
const FAILED_PAYMENT_STATUSES = ['failed'];

// Razorpay payment/refund status strings ('captured', 'processed', ...)
// don't match the Paid/Pending/Failed vocabulary the UI shows — normalize
// here once so the status badge, filters and stat cards all agree.
export function getInvoiceStatus(invoice) {
  const raw = invoice?.payment?.status || invoice?.status;
  if (invoice?.type === 'failed' || FAILED_PAYMENT_STATUSES.includes(raw)) {
    return 'failed';
  }
  if (PAID_PAYMENT_STATUSES.includes(raw)) return 'paid';
  return 'pending';
}

export const INVOICE_STATUS_LABEL = {
  paid: 'Paid',
  pending: 'Pending',
  failed: 'Failed',
};

export const INVOICE_STATUS_TONE = {
  paid: statusBadgeTones.success,
  pending: statusBadgeTones.warning,
  failed: statusBadgeTones.error,
};

export const INVOICE_STATUS_FILTER_OPTIONS = [
  { value: null, label: 'All Status' },
  { value: 'paid', label: 'Paid' },
  { value: 'pending', label: 'Pending' },
  { value: 'failed', label: 'Failed' },
];

// Invoice amounts live under `items[0].amount` — this is the only field that
// reflects a refund's actual (reversed) amount; `payment.amount` on a refund
// invoice still holds the original payment amount, not the refund amount.
export function getInvoiceAmount(invoice) {
  return invoice?.items?.[0]?.amount ?? invoice?.payment?.amount ?? 0;
}

export function formatBillingPeriodLabel(billingPeriod, toDateValue) {
  const start = toDateValue(billingPeriod?.start);
  const end = toDateValue(billingPeriod?.end);
  if (!start || !end) return 'N/A';
  return `${start.toDateString()} - ${end.toDateString()}`;
}
